import { joinCn } from '../util';
import { BreadCrumbsSize } from './constant';

const style = {
  vBreadcrumbsPathItem(
    isActived: boolean,
    size: BreadCrumbsSize | Lowercase<BreadCrumbsSize>,
    disabled: boolean,
  ) {
    return joinCn(
      'mr-1 last:mr-0',
      'w-fit',
      isActived ? 'font-bold text-primary-500' : 'text-gray-600',
      {
        'text-body-l': size === BreadCrumbsSize.MEDIUM,
        'text-headline-m': size === BreadCrumbsSize.LARGE,
      },
      {
        'cursor-not-allowed': disabled,
        'cursor-pointer': !disabled,
      },
    );
  },

  vBreadcrumbsPathItemIcon(isActived: boolean) {
    return joinCn(
      '!h-6 !w-6',
      isActived
        ? 'fill-Primary-Vuex-Navy stroke-Primary-Vuex-Navy text-primary-500'
        : 'fill-gray-300 stroke-gray-300 text-gray-300',
    );
  },

  vBreadcrumbsEllipsis: (isOpen: boolean) =>
    joinCn('!h-5 !w-5 rounded-sm text-gray-600', isOpen && 'bg-tertiary-200'),
} as const;

export default style;
